ckdc.ready(function ($) {
  if (typeof ckdc == 'undefined') {
    return;
  }

  if ( typeof ckdc.premiumLock === 'undefined' ) {
	return;
  }

  function openPopup( type ) {
	var eventName = 'recipe-' + type;
	ckdc.events.viewPromotion( 'popup', eventName );

	var lockColor = ( 'premium' == type ? 'green' : 'blue' );
	var beforeContent =
	    '<div class="lock-wrapper">' +
	    '  <img class="lock-img" src="' +
	    ckdc.imageDir + 'lock-' + lockColor + '.svg' +
	    '">' +
	    "</div>" +
	    '<div class="side-wrapper">' +
	    '  <img class="desktop" src="' +
	    ckdc.imageDir + type + '-lock-desktop.jpg' +
	    '">' +
	    '  <img class="mobile" src="' +
	    ckdc.imageDir + type + '-lock-mobile.jpg' +
	    '">' +
	    "</div>";

	var content =
	    '<div class="card-body">' +
	    '  <h5 class="card-title"> ' +
	    ckdc.premiumLock[type].title +
	    "</h5>" +
	    '  <p class="card-text">' +
	    ckdc.premiumLock[type].desc +
	    "</p>" +
	    '<div class="card-buttons">' +
	    '<a href="' +
	    ckdc.premiumLock[type].checkoutUrl +
	    '" class="start-my-free-trial" onclick="ckdc.events.selectPromotion(\'popup\', \'' + eventName + '\', \'checkout\');">' +
	    ckdc.premiumLock.checkoutTitle +
	    "</a>" +
	    '  <a href="' +
	    ckdc.premiumLock[type].signupUrl +
	    '" class="learn-more" onclick="ckdc.events.selectPromotion(\'popup\', \'' + eventName + '\', \'signup\');">' +
	    ckdc.premiumLock.signupTitle +
	    "</a>" +
	    "</div>" +
	    "</div>" +
	    '<div class="card-footer">' +
	    ckdc.premiumLock.footer +
	    "</div>";

	ckdc.simplebox.open(content, {
	  wrapperClasses: 'cta-premium-lock cta-' + type + '-lock',
	  beforeContent: beforeContent,
	  requireButtonClose: true,
	  closeButton: ( 'premium' == type ? false : true ),
	});
  }

  function lockedFeatureEvent(e) {
	if ( typeof ckdc.premiumLock === 'undefined' ) {
	  return true;
	}

	openPopup( 'feature' );

	e.preventDefault();
	e.stopPropagation();
	if ( jQuery( this ).is( 'select' ) ) {
	  /* Make sure some older browsers do not open dropdown. */
	  this.blur();
	  window.focus();
	}
	return false;
  }

  function premiumPopup() {
	if ( typeof ckdc.premiumLock === 'undefined' ) {
	  return;
	}

	openPopup( 'premium' );
	ckdc.body.css( 'overflow', 'hidden' );
  }

  function setupContent(content) {
	var lockedFeature = content.find(".feature-lock");
	lockedFeature.each(function () {
	  var $this = $(this);
	  var events = 'click touchstart';
	  if ( $this.is('select') ) {
		events = events + ' mousedown';
	  }
	  $this.on(events, lockedFeatureEvent);
	});
  }

  function showPremiumCount( count ) {
	var text = ckdc.premiumLock.premium.countdown;

	text = text.replace( '%%COUNT%%', count + '/3' );
	text = text.replace( '%%LINK%%', ckdc.premiumLock['premium'].checkoutUrl );

	jQuery( '<div class="premium-count">'
			+ '<div class="close"><i class="fa fa-times" aria-hidden="true" onclick="jQuery( this ).parents(\'.premium-count\').remove();"></i></div>'
			+ '<div class="content">'
			+ text
			+ '</div>'
			+ '</div>' ).appendTo( 'body' );
  }

  /* Setup both an event handler on features, and a fall-back catch on body. */
  ckdc.body.on('click', '.feature-lock', lockedFeatureEvent);
  ckdc.body.on('feature-lock', lockedFeatureEvent);
  ckdc.setup.addSetupContent('feature-lock', setupContent);

  /* Event to show premium popup */
  ckdc.body.on('premium-popup', premiumPopup);

  /* Premium content */
  if ( ckdc.premiumLock.isPremium ) {
	var c = ckdc.premium.getContentUsed();
	if ( ! c.includes( ckdc.premiumLock.contentId ) ) {
	  /* Max premium items shown */
	  if ( c.length >= 3 ) {
		premiumPopup();
	  } else {
		c.push( ckdc.premiumLock.contentId );
		ckdc.premium.setContentUsed( c );
		showPremiumCount( c.length );
	  }
	} else {
	  showPremiumCount( c.length );
	}
  }
});
